import React, { useState } from "react";
import {
  Container,
  IconButton,
  Box,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { firestore as db } from "../components/firebase.config";
import CreateChecklistWizard from "../components/CreateChecklistWizard"; // ✅ IMPORT WIZARD
import AdminChecklistView from "../components/AdminChecklistView";const AdminChecklist = ({ email }) => {
  const [openWizard, setOpenWizard] = useState(false); // ✅ Renamed for clarity
  const [selectedChecklist, setSelectedChecklist] = useState(null);  const handleOpenWizard = () => {
    setOpenWizard(true);
    setSelectedChecklist(null);
  };

  const handleCloseWizard = () => {
    setOpenWizard(false);
    setSelectedChecklist(null);
  };

  const handleEditChecklist = (checklist) => {
    setSelectedChecklist(checklist);
    setOpenWizard(true);
  };

  return (
    <Container>
      <Box flexGrow={1} minHeight={10} m={3}/>

      {/* Conditionally render the Add button only when the wizard is closed */}
      {!openWizard && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <IconButton
            onClick={handleOpenWizard}
            sx={{
              backgroundColor: "blue",
              color: "white",
              borderRadius: "50%",
              minWidth: "60px",
              minHeight: "60px",
              fontSize: "1.5rem",
              "&:hover": { backgroundColor: "darkblue" },
            }}
          >
            <Add />
          </IconButton>
        </Box>
      )}

      {/* ✅ Display the CreateChecklistWizard when openWizard is true */}
      {openWizard ? (
        <CreateChecklistWizard
          onClose={handleCloseWizard}
          selectedChecklist={selectedChecklist}
        />
      ) : (
        <AdminChecklistView onEditChecklist={handleEditChecklist} />
      )}
    </Container>
  );
};export default AdminChecklist;